if (document.body.id === "Contact" || document.body.id === "IsolatedContact") {
	let form = document.querySelector("form");

	document.querySelectorAll("#intro .contact-options .option").forEach((element, index) => {
		setTimeout(() => element.classList.add("show"), index * 250);
	});

	form.addEventListener("submit", event => {
		event.preventDefault();
		let data = new FormData(form);
		let query = Array.from(data.keys()).map(key => `${encodeURI(key)}=${encodeURIComponent(data.get(key))}`);

		form.classList.add("locked");
		form.setAttribute("message", "Sending...");

		fetch(`/contact/submit?${query.join("&")}`, {
			method: "POST"
		})
		.then(res => res.ok)
		.then(status => {
			form.setAttribute("message", status ? "Thank you!" : "Something went wrong, reload the page and try again.");
		});
	});
}